<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">List Retur Supplier Feedback</div>
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="10"
          data-key="doc_number"
          :rowHover="true"
          :loading="loading1"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col">
                <label for="" style="font-size: 14px">Nomor Bon</label>
                <div>
                  <InputText
                    type="text"
                    v-model="filters.doc_number"
                    placeholder="Nomer Bon"
                  />
                </div>
              </div>
              <div class="p-col">
                <label for="" style="font-size: 14px">Tanggal Feedback</label>
                <div>
                  <InputText
                    id="doc-date"
                    type="date"
                    v-model="filters.doc_date"
                    placeholder="Tanggal bon"
                  />
                </div>
              </div>
            </div>

            <div class="p-grid p-fluid p-justify-center">
              <div class="p-col-12 p-md-4 p-lg-4">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="saveFilters()"
                  v-shortkey.push="['enter']"
                  @shortkey="saveFilters()"
                />
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data daftar retur. Mohon tunggu</template
          >
          <Column header="Kode Supplier">
            <template #body="slotProps">
              <span>{{ slotProps.data.supplier_code }}</span>
            </template>
          </Column>
          <Column header="Nama Supplier">
            <template #body="slotProps">
              <span>{{ slotProps.data.supplier_name }}</span>
            </template>
          </Column>
          <Column header="Nomor Bon">
            <template #body="slotProps">
              <span>{{ slotProps.data.doc_number }}</span>
            </template>
          </Column>
          <Column header="Tanggal Bon">
            <template #body="slotProps">
              <span>{{ slotProps.data.doc_date }}</span>
            </template>
          </Column>

          <Column header="Total Barang">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_item }}</span>
            </template>
          </Column>
          <Column header="Total Harga">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_price | currency }}</span>
            </template>
          </Column>
          <Column
            headerStyle="width: 12rem"
            bodyStyle="text-align: center; overflow: visible"
          >
            <template #body="slotProps">
              <div>
                <router-link
                  :to="{
                    name: 'supplier-retur-feedback-detail',
                    query: { doc_number: slotProps.data.doc_number }
                  }"
                >
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-mr-2"
                  ></Button>
                </router-link>
                <Button
                  v-if="user.role == 'MAIN_PURCHASING'"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDelete(slotProps)"
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>

        <Dialog
          :visible.sync="deleteDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="supplier_return">
              Apakah kamu yakin ingin menghapus
              <b>{{ supplier_return.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSupplierRetur(supplier_return)"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

var moment = require('moment')

export default {
  data() {
    return {
      filters: {
        doc_date: '',
        doc_number: '',
        jenis_retur: ''
      },
      selectedSupplier: { id: '', code: '', name: '' },
      selectedSuppliers: null,
      moment: moment,
      filters1: {},
      loading1: null,
      expandedRows: [],
      autoFiltered: [],
      items: null,
      deleteDialog: false,
      confirmDialog: false,
      supplier_return: {},
      jenis_retur_filtered: null,
      jenis_retur: [{ type: 'RETURN' }, { type: 'TRANSFER ITEM' }]
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getSupplierReturList()
    this.getListSupplier()
  },
  methods: {
    getListSupplier() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/suppliers`)
        .then(response => {
          if (response.status === 200) {
            this.selectedSuppliers = response.data.data.suppliers
          }
        })
    },
    saveFilters() {
      this.getSupplierReturList()
    },
    searchTypeRetur(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.jenis_retur_filtered = [...this.jenis_retur]
        } else {
          this.jenis_retur_filtered = this.jenis_retur.filter(item => {
            return item.type.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    checkStatus(status) {
      if (status == 1) {
        // return Confirmed Hijau
        return 'Confirmed'
      } else {
        // return Pending merah
        return 'Pending'
      }
    },

    getSupplierReturList() {
      let doc_num = this.filters.doc_number || ''
      let doc_date = this.filters.doc_date || ''

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/supplier/result/list?doc_number=${doc_num}&doc_date=${doc_date}`
        )
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.items = response.data.data.supplier_return
          } else {
            console.error('gagal get')
          }
        })
    },

    confirmDelete(slotProps) {
      this.supplier_return = slotProps.data
      this.deleteDialog = true
    },
    deleteSupplierRetur(supplier_return) {
      const doc_number = supplier_return.doc_number
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/dashboard/supplier/result?doc_number=${doc_number}`
        )
        .then(response => {
          this.deleteDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Delete Success',
              detail: 'Data berhasil dihapus',
              life: 3000
            })
            this.getSupplierReturList()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Terjadi Kesalahan',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
